export default "\n<app-shell>\n    <!-- <h1>hi batman</h1> -->\n    <router-outlet></router-outlet>\n    <app-footer></app-footer>\n</app-shell>\n"